<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl ? `master/bank/${inputs.id}` : `master/bank`
				"
			>
				<div class="form-group row align-items-center">
					<div class="col-sm-12">
						<app-input
							id="inputs_early_bird_calculation"
							list-value-field="Early Bird Calculation"
							type="single-checkbox"
							v-model="inputs.early_bird_calculation"
						/>
					</div>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_bank_name" class="col-sm-3 mb-0">
						Bank Name
					</label>
					<app-input
						id="inputs_bank_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.bank_name"
						:placeholder="'Bank Name'"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_bank_code" class="col-sm-3 mb-0">
						Bank Code
					</label>
					<app-input
						id="inputs_bank_code"
						class="col-sm-9"
						type="text"
						v-model="inputs.bank_code"
						:placeholder="'Bank Code'"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_bank_logo" class="col-sm-3 mb-0">
						Bank Logo
					</label>
					<app-input
						id="inputs_bank_logo"
						class="col-sm-9"
						type="file"
						v-model="inputs.bank_logo"
						label="Bank Logo"
						required
					/>
				</div>

				<!-- note size logo -->
				<div class="form-group row align-items-center">
					<label for="inputs_bank_logo" class="col-sm-3 mb-0">
						&nbsp;
					</label>
					<div class="col-sm-9">
						<small class="text-muted">
							Note: Size logo 100x34px
						</small>
					</div>
				</div>

				<!-- <div class="form-group row align-items-center">
					<label for="inputs_is_active" class="col-sm-3 mb-0">
						&nbsp;
					</label>
					<div class="col-sm-8">
						<app-input
							id="inputs_is_active"
							:list-value-field="$t('is_active')"
							type="single-checkbox"
							v-model="inputs.is_active"
						/>
					</div>
				</div> -->
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
	},
	data() {
		return {
			preloader: false,
			inputs: {
			},
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	methods: {
		submit() {
			if (!(this.inputs.bank_logo instanceof File)) {
				delete this.inputs.bank_logo;
			}

			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
